const ref = { current: {} };
export function resetUsing() {
  ref.current = {};
}
export function getUsing() {
  return { ...ref.current };
}
export function onUse(name) {
  ref.current[name] = true;
}
